export interface LocaleSeparators {
    group: string;
    decimal: string;
}

export interface ParsedNumber {
    empty: boolean;
    valid: boolean;
    value: number | null;
}

export function getLocaleSeparators(locale: string): LocaleSeparators {
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);

    const group = parts.find(part => part.type === 'group')?.value ?? '.';
    const decimal = parts.find(part => part.type === 'decimal')?.value ?? ',';

    return { group, decimal };
}

export function parseLocaleNumber(input: string, separators: LocaleSeparators): ParsedNumber {
    const trimmed = (input ?? '').trim();

    if (trimmed === '') {
        return { empty: true, valid: true, value: null };
    }

    let normalized = trimmed.split(separators.group).join('');
    normalized = normalized.replace(/\s/g, '');

    if (separators.decimal !== '.') {
        normalized = normalized.split(separators.decimal).join('.');
    }

    if (!/^-?\d+(\.\d*)?$/.test(normalized)) {
        return { empty: false, valid: false, value: null };
    }

    const value = Number(normalized);

    if (Number.isNaN(value)) {
        return { empty: false, valid: false, value: null };
    }

    return { empty: false, valid: true, value };
}

export function formatLocaleNumber(value: number | null | undefined, locale: string): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return '';
    }

    return new Intl.NumberFormat(locale, { maximumFractionDigits: 2, useGrouping: true }).format(value);
}
